import { FormattedMessage } from 'react-intl';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';

/*
  Returns free-trial duration text for the Checkout page
  couponTrialDuration will be either "x month(s)", "x week(s)" or "x day(s)". 
  We need to handle singular & plural month/week/day text which requires separate translations.
*/

export default function getPlusCheckoutTrialDurationText(purchaseTier: PurchaseTier, couponTrialDuration?: string) {
  const tierName = purchaseTier === 'peak' ? 'Peak' : 'Plus';

  if (couponTrialDuration) {
    const durationData = couponTrialDuration.split(' ');
    const durationNum = Number(durationData[0]);
    const durationType = durationData[1];

    if (durationType.includes('month')) {
      return (
        <FormattedMessage
          defaultMessage="Try {tierName} free for {durationNum, plural, one {1 month} other {{durationNum} months}}"
          values={{ tierName, durationNum }}
        />
      );
    }

    if (durationType.includes('week')) {
      return (
        <FormattedMessage
          defaultMessage="Try {tierName} free for {durationNum, plural, one {1 week} other {{durationNum} weeks}}"
          values={{ tierName, durationNum }}
        />
      );
    }

    if (durationType.includes('day')) {
      return (
        <FormattedMessage
          defaultMessage="Try {tierName} free for {durationNum, plural, one {1 day} other {{durationNum} days}}"
          values={{ tierName, durationNum }}
        />
      );
    }
  }

  return purchaseTier === 'peak' ? (
    <FormattedMessage defaultMessage="Try Peak free for 7 days" />
  ) : (
    <FormattedMessage defaultMessage="Try Plus free for 7 days" />
  );
}
